import React from "react";

// --- CSS --- //
import "../styles/search-bar.css";

// --- ASSETS --- //
import SearchIcon from "@mui/icons-material/Search";

const SearchBar = ({ isFocused, setIsFocused, searchQuery, setSearchQuery, placeholder }) => {

    // Handlers for focus, blur, and input change
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => setIsFocused(false);
    const handleInputChange = (e) => setSearchQuery(e.target.value);

    return (
        <div className={`search-bar-container ${isFocused ? "focused" : ""}`}>
            <SearchIcon />
            <input
                className="search-bar"
                placeholder={placeholder}
                value={searchQuery}
                onChange={handleInputChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            />
        </div>
    );
};

export default SearchBar;